var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put } from 'redux-saga/effects';
import { getSummaryDataSuccessAction, getConfigurationDataFailureAction } from '../actions';
import { BrandedNotificationGetService } from '../services';
function fetchBrandedNotificationSummary(brandedNotificationService, brandedNotificationInputs, coCode) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield brandedNotificationService.getBrandedNotificationSummary(brandedNotificationInputs, coCode);
    });
}
export function* fetchBrandedNotificationSummarySaga(action, brandedNotificationService = new BrandedNotificationGetService()) {
    const { brandedNotificationInputs, coCode } = action.payload;
    try {
        const response = yield call(fetchBrandedNotificationSummary, brandedNotificationService, brandedNotificationInputs, coCode);
        if (response.hasOwnProperty('result')) {
            if (response.result.status) {
                yield put(getSummaryDataSuccessAction(response.result));
            }
            else {
                yield put(getConfigurationDataFailureAction(response.result.errorResponse.errorResponse));
            }
        }
        else {
            const response = {
                status: true,
                errorResponse: {
                    errorCode: 0,
                    errorResponse: ''
                },
                templateDetailList: []
            };
            yield put(getSummaryDataSuccessAction(response));
        }
    }
    catch (error) {
        yield put(getConfigurationDataFailureAction(error));
    }
}
//# sourceMappingURL=fetchBrandedNotificationSummarySaga.js.map